import { CircularProgress } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

function usePines() {
  const [pines, setPines] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    fetch('https://api.edicionesmilenio.com/api/pines')
      .then((res) => res.json())
      .then((data) => {
        setIsLoading(false);
        let p = data?.data?.map((pin) => {
          return {
            pin: pin?.pin,
            institution: pin?.institution?.name,
            grade: pin?.grade?.name,
            expirationDate: pin?.expirationDate,
          };
        });
        setPines(p);
      });
  }, []);

  return { pines, setPines, isLoading };
}

export function Pines(props) {
  const { pines, isLoading } = usePines();
  const navigate = useNavigate();

  const routeChange = (id) => {
    navigate(`/admin/pines-update/${id}`);
  };

  const columns = [
    {
      name: 'pin',
      label: 'Pin',
    },
    {
      name: 'institution',
      label: 'Institución',
    },
    {
      name: 'grade',
      label: 'Grado',
    },
    {
      name: 'expirationDate',
      label: 'Fecha de expiración',
    },
  ];

  function handleDelete(rowsDelete) {
    rowsDelete?.data?.forEach(async (row) => {
      let pin = pines[row?.dataIndex];
      let res = await fetch(
        `https://api.edicionesmilenio.com/api/pines/pin/${pin?.pin}`,
        {
          method: 'GET',
        }
      );
      let { data } = await res.json();
      let response = await fetch(
        `https://api.edicionesmilenio.com/api/pines/${data?._id}`,
        {
          method: 'DELETE',
        }
      );
      if (response.status === 200) {
        return true;
      }
      let json = await response.json();
      return false;
    });
  }
  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, desde esta sección podrás visualizar la lista de
        pines creados en la plataforma, puedes usar las herramientas, filtrar,
        buscar, imprimir, descargar, para gestionar este módulo. Ten mucha
        precaución de eliminar alguno de ellos, si ya cuenta con una asociación
        a un usuario, este proceso podrá generar la pérdida de acceso e
        información que no se puede recuperar.
      </p>
      {!isLoading ? (
        <MUIDataTable
          title={'Pines'}
          data={pines}
          columns={columns}
          options={{
            print: false,
            filterType: 'dropdown',
            onRowsDelete: (rowsDeleted) => {
              handleDelete(rowsDeleted);
            },
          }}
        />
      ) : (
        <CircularProgress color="primary" />
      )}
    </div>
  );
}
